"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInstantConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.3308 3.38384L13.7533 2.38911L4.19383 12.3517L4.76612 13.3527L7.70798 13.8519L7.19271 15.8137L5.07383 20.6936L5.64691 21.6989L15.1217 11.0654L14.5475 10.0698L12.4389 10.5853L14.3308 3.38384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.7559 2.38767L4.19113 12.3565L7.13298 12.8558L5.07191 20.7027L14.5467 10.0692L11.8639 9.58914L13.7559 2.38767Z",
    fill: "url(#paint0_linear_719_168991)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_168991",
    x1: "10.3925",
    y1: "2.01328",
    x2: "8.27246",
    y2: "21.059",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#2080F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    "stop-color": "#5BC9F5"
  }))));
}

var MemoSvgInstantConfirm = /*#__PURE__*/React.memo(SvgInstantConfirm);
var _default = MemoSvgInstantConfirm;
exports["default"] = _default;